import { pcWorthLatLng } from "common";

import { GoogleLatLng } from "common/types/google-maps";
import { metersToKilometers } from "utils/number";

export const getKmDistanceFromPCWorth = async (
  customerLatLng: GoogleLatLng
) => {
  const service = new google.maps.DistanceMatrixService();
  if (service) {
    const response = await service?.getDistanceMatrix({
      origins: [pcWorthLatLng],
      destinations: [customerLatLng],
      travelMode: google.maps.TravelMode.DRIVING,
      unitSystem: google.maps.UnitSystem.METRIC,
      avoidTolls: true,
    });
    if (response?.rows?.length > 0) {
      if (response?.rows[0]?.elements?.length > 0) {
        const distanceInMeters =
          response?.rows[0]?.elements[0]?.distance?.value;
        const distanceInKm = metersToKilometers(distanceInMeters);
        const distanceToNum = parseFloat(distanceInKm);
        return isNaN(distanceToNum) ? 0 : distanceToNum;
      }
    }
  }
  return 0;
};
